<template>
  <v-form
    ref="lldDetail"
    v-model="isValidationOk"
    lazy-validation>
    <v-container
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        wrap>
        <v-flex
          xs6
          lg1
          md1>
          <v-text-field
            v-model.number="lld.lldNumber"
            :label="`${ $t('Number') }`"
            :count="3"
            :disabled="!isNewLld"
            data-testId="text-field-Number"
            mask="###"
            class="dover-input"
            @change="onSelectionUpdate()" />
        </v-flex>
        <v-flex
          xs6
          md2
          lg2>
          <v-switch
            v-model="lld.enabled"
            :label="`${ $t('Enabled') }`"
            data-testId="switch-Enabled"
            class="dover-input text-xs-center"
            @change="onSelectionUpdate()"/>

        </v-flex>
        <v-flex
          xs12
          lg3
          md3>
          <v-text-field
            v-model.trim="lld.lldDescription"
            :rules="rules.required.concat(rules.maxLen_30)"
            :counter="30"
            :label="`${ $t('Name') }`"
            data-testId="text-field-Name"
            class="dover-input"
            @change="onSelectionUpdate()"/>
        </v-flex>
        <v-flex
          xs6
          md4
          lg4>
          <v-select
            v-model="lld.tankNumber"
            :items="tanks"
            :label="`${ $t('Tank') }`"
            data-testId="select-Tank"
            item-text="tankDescription"
            item-value="tankNumber"
            class="dover-input"
            outline
            dense
            @change="onSelectionUpdate()"/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        wrap>
        <v-flex
          xs12
          md12
          lg12>
          <span>
            {{ 'MAGLINK I/O' }}
          </span>
          <hr>
        </v-flex>
        <v-flex
          xs6
          md3
          lg3>
          <v-select
            v-model="lld.ioSensorAddress"
            :items="ioAddresses"
            :label="`${ $t('Address') }`"
            data-testId="select-Address"
            item-text="desc"
            item-value="code"
            class="dover-input"
            outline
            dense
            @change="onSelectionUpdate()"/>
        </v-flex>
        <v-flex
          xs6
          md3
          lg3>
          <v-select
            v-model="lld.ioSensorPosition"
            :items="ioPositions"
            :label="`${ $t('Position') }`"
            :disabled="lld.ioSensorAddress === 0"
            data-testId="select-Position"
            item-text="desc"
            item-value="code"
            class="dover-input"
            outline
            dense
            @change="onSelectionUpdate()"/>
        </v-flex>
        <v-flex
          v-if="lld.ioSensorAddress !== 0"
          xs6
          md3
          lg3>
          <v-text-field
            v-model.number="lld.sensorSpan"
            :counter="5"
            :rules="rules.required.concat(rules.span)"
            :label="`${ $t('Sensor Span (psi)') }`"
            data-testId="text-field-Sensor-Span"
            class="dover-input"
            @change="onSpanChanged()"/>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      fill-height
      fluid
      grid-list-xl>
      <v-layout
        wrap>
        <v-flex
          xs12
          md12
          lg12>
          <span>
            {{ 'LIM' }}
          </span>
          <hr>
        </v-flex>
        <v-flex
          xs6
          md3
          lg3>
          <v-select
            v-model="lld.limStpAddress"
            :items="limAddresses"
            :label="`${ $t('Device') }`"
            data-testId="select-Device"
            item-text="desc"
            item-value="code"
            class="dover-input"
            outline
            dense
            @change="onSelectionUpdate()"/>
        </v-flex>
        <v-flex
          xs6
          md3
          lg3>
          <v-select
            v-model="lld.limStpPosition"
            :items="limPositions"
            :label="`${ $t('Channel') }`"
            :disabled="lld.limStpAddress == 0"
            data-testId="select-Channel"
            item-text="desc"
            item-value="code"
            class="dover-input"
            outline
            dense
            @change="onSelectionUpdate()"/>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>

import { i18n } from '@/i18n'
import Vue from 'vue'

export default {
  props: {
    isNewLld: {
      type: Boolean,
      require: true,
      default: () => false
    },
    tanks: {
      type: Array,
      required: true,
      default: () => []
    },
    lld: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    ioAddresses: [],
    limAddresses: [],
    ioPositions: [],
    limPositions: [],
    rules: {
      span: [ v => Vue.prototype.Maglink.RulesRange(v, 20.00, 100.00) ],
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      maxLen_30: [ v => Vue.prototype.Maglink.RulesMaxLen(v, 30) ]
    }
  }),
  mounted () {
    this.ioAddresses.push({ code: 0, desc: i18n.t('OFF') })
    for (let i = 1; i <= 1; i++) {
      this.ioAddresses.push({ code: i, desc: i.toString() })
    }
    this.limAddresses.push({ code: 0, desc: i18n.t('OFF') })
    for (let i = 1; i <= 4; i++) {
      this.limAddresses.push({ code: i, desc: i.toString() })
    }
    this.ioPositions.push({ code: 0, desc: i18n.t('OFF') })
    for (let i = 1; i <= 16; i++) {
      this.ioPositions.push({ code: i, desc: i.toString() })
    }
    this.limPositions.push({ code: 0, desc: i18n.t('OFF') })
    for (let i = 1; i <= 4; i++) {
      this.limPositions.push({ code: i, desc: i.toString() })
    }
  },
  methods: {
    onSelectionUpdate () {
      this.$emit('dataChanged', true)
    },
    onSpanChanged () {
      this.lld.sensorSpan = parseFloat(this.Maglink.RoundFormat(this.lld.sensorSpan, 2))
      this.onSelectionUpdate()
    },
    snack (color, message) {
      message = i18n.t('Line leak config detail') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
